import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import BasketPaymentDetailsTemplate from './BasketPaymentDetailsTemplate';
import { rem } from 'polished';

export const BasketPaymentDetailsStyled = styled(BasketPaymentDetailsTemplate)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey16};

    .Collapsible__contedescriptionntInner {
        padding-bottom: ${rem(30)};
    }

    .titleWrapperButton {
        width: 100%;
    }

    .titleWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: ${rem(43)} 0;
        width: 100%;

        .title {
            font-size: ${({ theme }) => theme.fontSizes.textBig};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: 1.4;
        }

        svg {
            height: ${rem(14)};
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                    stroke-width: 2;
                }
            }
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .description {
        span {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            display: block;
            padding-bottom: ${rem(4)};
        }

        .link {
            text-decoration: underline;
            cursor: pointer;
            background: none;
            border: none;
            font-size: ${rem('14px')};
            padding: 0;
        }
    }

    .cashSummary {
        margin: ${rem(20)} 0;

        @media (min-width: ${breakpoints.md}px) {
            display: flex;
            justify-content: space-between;
        }

        .leftSection,
        .rightSection {
            width: 100%;

            @media (min-width: ${breakpoints.md}px) {
                width: 50%;
            }
        }

        .leftSection {
            font-size: ${({ theme }) => theme.fontSizes.textBase};

            p {
                padding-bottom: ${rem(20)};
            }

            @media (min-width: ${breakpoints.md}px) {
                margin: 0 ${rem(8)} 0 0;
            }
        }

        .rightSection {
            p {
                display: flex;
                justify-content: space-between;
                border-top: 1px solid ${({ theme }) => theme.colors.grey25};
                padding: ${rem(12)} ${rem(12)} 0 ${rem(12)};

                .price {
                    font-weight: ${({ theme }) => theme.fontWeights.textBold};
                }
            }
            @media (min-width: ${breakpoints.md}px) {
                margin: 0 0 0 ${rem(8)};
            }
        }

        .totalPrice {
            padding: ${rem(12)} !important;
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            border-bottom: 1px solid ${({ theme }) => theme.colors.grey25};
        }
    }

    .financeSummary {
        margin-top: ${rem('32px')};
        background: ${({ theme }) => theme.colors.grey8};
        padding: ${rem(24)};

        .infoIcon {
            width: ${rem(16)};
            height: ${rem(16)};

            svg {
                g {
                    circle,
                    line {
                        stroke: ${({ theme }) => theme.colors.primary};
                    }
                }
            }
        }

        .monthlyPaymentDesktop,
        .monthlyPaymentDetailDesktop {
            display: none;

            @media (min-width: ${breakpoints.md}px) {
                display: flex;
            }
        }

        .monthlyPaymentMobile,
        .monthlyPaymentDetailMobile {
            display: block;

            @media (min-width: ${breakpoints.md}px) {
                display: none;
            }
        }

        .monthlyPaymentDesktop {
            font-size: ${({ theme }) => theme.fontSizes.textMedium};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            justify-content: space-between;
        }

        .monthlyPaymentDetailDesktop {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            justify-content: space-between;
            padding: ${rem(8)} 0 ${rem(24)} 0;

            .link {
                cursor: pointer;
                background: none;
                border: none;
                border-bottom: 1px solid ${({ theme }) => theme.colors.black};
                padding: 0;
            }
        }

        .monthlyPaymentMobile,
        .monthlyPaymentDetailMobile {
            padding-bottom: ${rem(12)};

            .price {
                display: block;
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                font-size: ${({ theme }) => theme.fontSizes.textSupBase};

                .suffix {
                    font-size: ${({ theme }) => theme.fontSizes.textBase};
                }
            }

            .link {
                display: block;
                text-decoration: underline;
                cursor: pointer;
                border: none;
                background: none;
                padding: 0;
                font-size: ${({ theme }) => theme.fontSizes.textBase};
            }

            span {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                padding-bottom: ${rem(4)};
            }
        }

        .monthlyPaymentSummary {
            .monthlyPaymentItem {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                display: flex;
                justify-content: space-between;
                padding-bottom: ${rem(15)};

                .price {
                    font-weight: ${({ theme }) => theme.fontWeights.textBold};
                }
            }
        }

        .personalizeButton {
            text-transform: uppercase;
            cursor: pointer;
            text-align: center;
            margin: ${rem(8)} auto;
            border: 1px solid ${({ theme }) => theme.colors.black};
            color: ${({ theme }) => theme.colors.black};
            font-size: ${({ theme }) => theme.fontSizes.textTiny};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            padding: ${rem('15px')} ${rem('24px')} ${rem('16px')};
            white-space: nowrap;
            display: flex;
            width: fit-content;

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.white};
                background: ${({ theme }) => theme.colors.black};
                border-color: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .needHand {
        background: ${({ theme }) => theme.colors.grey6};
        height: ${rem(40)};
        border-radius: ${rem(12)};
        align-items: center;
        justify-content: center;
        margin: ${rem(30)} 0;
        display: none;

        @media (min-width: ${breakpoints.sm}px) {
            display: flex;
        }

        &_label {
            font-size: ${({ theme }) => theme.fontSizes.h4};
            color: ${({ theme }) => theme.colors.grey5};
        }

        &_modalButton {
            background: none;
            margin: 0 ${rem(20)};
            border: none;
            font-size: ${({ theme }) => theme.fontSizes.h4};
            color: ${({ theme }) => theme.colors.red};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            cursor: pointer;

            svg {
                width: ${rem(14)};
                height: ${rem(10)};

                path {
                    fill: ${({ theme }) => theme.colors.red};
                }
            }

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.grey5};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.grey5};
                    }
                }
            }
        }

        &_phone {
            font-size: ${({ theme }) => theme.fontSizes.h4};
            color: ${({ theme }) => theme.colors.grey5};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            text-decoration: none;

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.red};
            }
        }
    }

    .legalText {
        margin-top: ${rem(32)};

        p {
            margin: unset;
            color: ${({ theme }) => theme.colors.grey16};
            font-size: ${({ theme }) => theme.fontSizes.textTiny};
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        }
    }

    .spinner {
        margin: 0 auto;
        padding: ${rem(20)} 0;
    }
`;
